import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedStudioRoute } from "../components/studio/ProtectedStudioRoute";
import { PublicLayout } from "../components/layout/PublicLayout";

const ArticlePage = lazy(() =>
  import("../pages/public/ArticlePage").then((module) => ({
    default: module.ArticlePage
  }))
);
const HomePage = lazy(() =>
  import("../pages/public/HomePage").then((module) => ({
    default: module.HomePage
  }))
);
const BlogPage = lazy(() =>
  import("../pages/public/BlogPage").then((module) => ({
    default: module.BlogPage
  }))
);
const NotFoundPage = lazy(() =>
  import("../pages/public/NotFoundPage").then((module) => ({
    default: module.NotFoundPage
  }))
);
const StudioDashboardPage = lazy(() =>
  import("../pages/studio/StudioDashboardPage").then((module) => ({
    default: module.StudioDashboardPage
  }))
);
const StudioEditorPage = lazy(() =>
  import("../pages/studio/StudioEditorPage").then((module) => ({
    default: module.StudioEditorPage
  }))
);
const StudioLayout = lazy(() =>
  import("../pages/studio/StudioLayout").then((module) => ({
    default: module.StudioLayout
  }))
);
const StudioLoginPage = lazy(() =>
  import("../pages/studio/StudioLoginPage").then((module) => ({
    default: module.StudioLoginPage
  }))
);
const StudioPostsPage = lazy(() =>
  import("../pages/studio/StudioPostsPage").then((module) => ({
    default: module.StudioPostsPage
  }))
);
const StudioSettingsPage = lazy(() =>
  import("../pages/studio/StudioSettingsPage").then((module) => ({
    default: module.StudioSettingsPage
  }))
);

function RouteFallback() {
  return (
    <div className="grid min-h-64 place-items-center px-4 py-12 text-[12px] tracking-[0.16em] text-blank-muted">
      جارٍ التحميل…
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route element={<ArticlePage />} path="article/:slug" />
          <Route element={<BlogPage />} path="page/:pageSlug" />
          <Route element={<Navigate replace to="/" />} path="tags" />
          <Route element={<Navigate replace to="/" />} path="tag/:tag" />
          <Route element={<Navigate replace to="/" />} path="about" />
        </Route>

        <Route element={<StudioLoginPage />} path="studio/login" />
        <Route element={<ProtectedStudioRoute />}>
          <Route element={<StudioLayout />} path="studio">
            <Route index element={<StudioDashboardPage />} />
            <Route element={<StudioPostsPage />} path="posts" />
            <Route element={<StudioEditorPage />} path="editor" />
            <Route element={<StudioEditorPage />} path="editor/:id" />
            <Route element={<StudioSettingsPage />} path="settings" />
          </Route>
        </Route>

        <Route element={<NotFoundPage />} path="*" />
      </Routes>
    </Suspense>
  );
}
